import {
  Component,
  DestroyRef,
  Inject,
  inject,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { PageEvent } from '@angular/material/paginator';
import { finalize, map, startWith, take, tap } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  LinkedAccountConstants,
  ModalPopupMessages,
  DashboardArChargesUi,
  ArAdditionalChargesChoice,
  ArAdditionalChargesChoiceValue,
  popupButtons,
  StatusCodes,
  validationErrorMessages,
  UserManagementConstants,
  CBPConstantMessages,
  popupWidth,
  pageType,
  ActionIcons,
  ACCEPTED_FILE_TYPES,
  MANIFEST_EMAIL_ACCEPTED_FILE_TYPES,
  MAX_MANIFEST_EMAIL_ATTACHMENTS,
  pageUrl,
  HawbStatus,
  AutoRateFeatureKeys,
  popupConditions,
  arInvoicefileNameExtension,
  ManifestPublishFormatOption,
  GridColumnsStorageNames,
  confirmCountdownSeconds,
} from '../../utility/constants';
import { readLoggedInUserEmailFromStorage } from '../../utility/stored-user-email.util';
import { ValidatorPattern } from '../../utility/validators.pattern';
import {
  GatewayMasterShipmentsGridContent,
  ScanShipmentBagPieceContent,
  ShipmentBagGridContent,
  ShipmentGatewayPieceGridContent,
} from '../../models/dynamic.model';
import { TableColumnsProp } from '../../models/tables.model';
import { SnakbarService } from '../../services/snakbar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { CommonService } from '../../services/common.service';
import { HawbService } from 'src/app/features/service/hawb.service';
import { ModalService } from '../../services/modal.service';
import { Observable, of, timer } from 'rxjs';
import { Router } from '@angular/router';
import { copyRateScaleInfoFormConfig } from 'src/app/features/components/rate-scales/rate-scales.config';
import { ValidatorService } from '../../services/form-control-validators.service';
import { CustomErrorTooltipComponent } from '../custom-error-tooltip/custom-error-tooltip.component';
import { InformationNoteComponent } from '../information-note/information-note.component';
import { AccountsPayableService } from 'src/app/features/service/accounts-payable.service';
import { apSftpFilesGridColumnConfig } from 'src/app/features/components/accounts-payable/accounts-payable.config';
import { SelectionService } from '../../services/selection.service';
import { SharedModule } from '../../shared.module';
import { userDetailsEvent } from 'src/app/features/components/accounts/accounts.config';
import { ManifestService } from 'src/app/features/service/manifest.service';
import { manifestPublishFormatColumns } from 'src/app/features/components/manifest/manifest.config';
import { defauthawbPagination, ufoShipmentsGridColumnsConfig } from '../../configs/common-configs';
import { CommonApiService } from '../../services/common-api.service';
import {
  CustomsCityProcessClearanceRequest,
  CustomsCityProcessClearanceResponse,
  CustomsCityValidateCustomsCityClearanceResponse,
} from '../../models/customs-city-clearance.model';
import {
  buildCustomsCityClearanceErrorLogData,
  CustomsCityClearanceStatusCodes,
  CustomsCityValidateChannelStatusCodes,
  hasQueuedCustomsCityClearance,
  isCustomsCityClearanceChannelValidationModule,
  parseCustomsCityClearanceResponse,
  parseCustomsCityValidateCustomsCityClearanceResponse,
  resolveCustomsCityClearanceSelectionPayload,
} from '../../utility/customs-city-clearance.util';
import { DataTableComponent } from '../data-table/data-table.component';
import { DataTableConfig } from '../data-table/data-table-config.interface';
import {
  buildManifestAttachmentDataTableConfig,
  buildMessagePopupGridConfig,
  resolveMessagePopupRowIdField,
  resolveMessagePopupStorageKey,
  updateZeroBasedPagingPayload,
} from './message-popup.data-table.util';

@Component({
  selector: 'app-message-popup',
  standalone: true,
  imports: [
    SvgIconComponent,
    CustomErrorTooltipComponent,
    InformationNoteComponent,
    SharedModule,
    DataTableComponent,
  ],
  templateUrl: './message-popup.component.html',
  styleUrl: './message-popup.component.scss',
})
export class MessagePopupComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  public messagePopupData: any;
  public multiPiecePhysicalCountInput = '';
  public multiPieceGatewayComments = '';
  public multiPieceSelectionMismatchText = '';
  public confirmValue!: string;
  public popupMessages = ModalPopupMessages;
  public readonly arAdditionalChargesModalCopy = DashboardArChargesUi;
  public readonly arAdditionalChargesChoice = ArAdditionalChargesChoice;
  public confirmCountdown = 0;
  public popupButtons = popupButtons;
  public popupConditions = popupConditions;
  public pageType = pageType;
  public fileType = '';
  public rangeOptions: any[] = [];
  public selectedRanges: Set<number> = new Set();
  public selectAllRanges = true;
  public summaryTableColumns: any;
  public isPrintDisable = false;
  public shipmentGatewayPieceGridColumns!: TableColumnsProp[];
  public shipmentGatewayPieceTableData!: ShipmentGatewayPieceGridContent[];
  public page!: string;
  public masterShipmentTableColumnConfig!: TableColumnsProp[];
  public masterShipmentTableData!: GatewayMasterShipmentsGridContent[];
  public tableisFrom!: string;
  public shipmentBagGridColumns!: TableColumnsProp[];
  public shipmentBagPieceTableData!: ShipmentBagGridContent[];
  public numberRangeDetailsGridColumns!: TableColumnsProp[];
  public numberRangeDetailsTableData!: ShipmentBagGridContent[];
  public selectedOption: string | null = null;
  public isCheckboxChecked: boolean = false;
  public fullmanFileErrorLogMessages!: Record<string, string[]>;
  selectedRowData: any;
  private isConfirmValueValid = true;
  /** `C` = CFS, `E` = ECCF; one type per submission. */
  public selectedClearanceTypeCode: 'C' | 'E' | null = null;
  /** Null until the user ticks ACAS themselves; the account config supplies the default. */
  private acasSelectionOverride: boolean | null = null;
  private isCustomsCityClearanceSubmitting = false;
  public messageText = '';
  public eventDescriptionData: any;
  public eventListDisplayMessage!: string;
  public eventListObj!: any;
  public actionIcons = ActionIcons;
  public copyRateScaleForm!: FormGroup;

  public duplicateList: Array<{
    id: string;
    shipmentIdentifier?: string;
    shipmentIdentifierValue?: string;
    shipmentId?: string;
    [k: string]: any;
  }> = [];
  public isDuplicateMulti = false;
  public duplicateSelection = new Map<string, string>();
  public singleDuplicateAction: string | null = '';
  public multiDuplicateAction: string | null = null;

  private readonly destroyRef = inject(DestroyRef);
  public apChargeCodeDetailsGridColumns!: TableColumnsProp[];
  public apChargeCodeDetailsTableData!: any[];
  public apInvoiceFetchFromSFTPMessage =
    ModalPopupMessages.apInvoiceFetchFromSFTPMessage;
  public apInvoiceFetchFromSFTPWarningMessage =
    ModalPopupMessages.apInvoiceFetchFromSFTPWarningMessage;
  public apSftpFilesGridColumns!: TableColumnsProp[];
  public apSftpFilesTableData: any[] = [];
  public apSftpFilesTotalCount = 0;
  public ufoShipmentsGridColumns!: TableColumnsProp[];
  public ufoShipmentsSearchPayload = {
    paging: { ...defauthawbPagination },
    searchText: ''
  };
  public ufoShipmentsRawData: any[] = [];
  public ufoShipmentsTableData: any[] = [];
  public ufoShipmentsTotalCount = 0;
  public isUfoShipmentsDataSearched = false;
  public ufoFilterStartDate: Date | null = null;
  public ufoFilterEndDate: Date | null = null;
  public invoiceDatePromptValue: Date | null = null;
  public invoiceDatePromptMinDate: Date | null = null;
  public invoiceDatePromptMaxDate: Date | null = null;
  public ufoFilterShipperConsignee = '';
  public ufoSelectedAccount: string | null = null;
  public ufoAccountOptions: { value: string; label: string }[] = [];
  public ufoAccountCtrl = new FormControl('');
  public filteredUfoAccountOptions: Observable<{ value: string; label: string }[]> = of([]);
  public isApSftpFilesDataSearched = false;
  public requiredPublishText = '';
  public areSelectedAgentsUniform = true;
  public selectedAgentData: string | null = null;
  public errorLogsHeaderText = ModalPopupMessages.errorLogsHeaderText;

  public readonly manifestAttachmentGridConfig =
    buildManifestAttachmentDataTableConfig();
  public gatewayRenderTableGridConfig?: DataTableConfig<any>;
  public arChargesGridConfig?: DataTableConfig<any>;
  public masterShipmentGridConfig?: DataTableConfig<any>;
  public bagShipmentGridConfig?: DataTableConfig<any>;
  public scanBagShipmentGridConfig?: DataTableConfig<any>;
  public multiBagSelectionGridConfig?: DataTableConfig<any>;
  public numberRangeGridConfig?: DataTableConfig<any>;
  public apChargeDetailGridConfig?: DataTableConfig<any>;
  public linkedAccountsGridConfig?: DataTableConfig<any>;
  public ufoShipmentsGridConfig?: DataTableConfig<any>;
  public apSftpFilesGridConfig?: DataTableConfig<any>;

  // Chips Autocomplete properties
  separatorKeysCodes: number[] = [ENTER, COMMA];
  emailCtrl = new FormControl('');
  filteredEmails!: Observable<string[]>;
  selectedEmails: string[] = [];
  allEmails: string[] = [];
  currentUserEmail: string = '';

  invoiceFileFormatOptions: Array<{ id: number; name: string }> = [];
  selectedFileFormats: number[] = [];

  emailSubject: string = '';
  emailBody: string = '';

  @ViewChild('emailInput') emailInput!: ElementRef<HTMLInputElement>;
  public setRateScaleCopyInfoWidth: any = {};
  public setRateScaleCopyInfoErrorTooltip: any = {};
  public setRateScaleCopyInfoTooltipEvent: any = {};
  public errorMessages!: any;
  @Input() onConfirm!: (value: any) => void;
  public apFileErrorLogMessages!: any;
  readonly acceptedFileTypes = ACCEPTED_FILE_TYPES;
  public scanBagShipmentGridColumns!: TableColumnsProp[];
  public scanShipmentBagTableData!: ScanShipmentBagPieceContent[];
  public multiBagSelectionGridColumns!: TableColumnsProp[];
  public multiBagSelectionTableData!: any[];
  public userDisplayedColumns = userDetailsEvent;
  public autoRateFailedErrorMessage!: any[];
  public hasNotAutoRatedSelection = false;
  public autoRatingMessage!: string;
  public autoRatingFailureDetailHeader = '';
  public autoRatingPreListCaption = '';
  /** Bold line above the error log (e.g. partial cancel success count). */
  public errorLogSuccessMessage = '';

  public isSendManifestViaEmail = false;
  public manifestSendToMe = true;
  public manifestEmailError = '';
  public selectedManifestFormat: ManifestPublishFormatOption | null = null;
  public selectedManifestFileFormat: string | null = null;
  public manifestEmailSubject = '';
  public manifestFormatOptions: ManifestPublishFormatOption[] = [];
  public manifestFileFormatOptions: Array<{ id: string; name: string }> = [];
  public readonly manifestAcceptedFileTypes = MANIFEST_EMAIL_ACCEPTED_FILE_TYPES;
  public readonly maxManifestAttachments = MAX_MANIFEST_EMAIL_ATTACHMENTS;
  public manifestAttachmentList: Array<{ displayName: string; storedFileName: string }> = [];
  public manifestSelectedEmails: string[] = [];
  public manifestEmailCtrl = new FormControl('');
  public isManifestAttachmentUploading = false;
  public manifestAttachmentTableColumns = manifestPublishFormatColumns;
  @ViewChild('manifestAttachmentInput') manifestAttachmentInput!: ElementRef<HTMLInputElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ref: MatDialogRef<MessagePopupComponent>,
    private readonly snakbarService: SnakbarService,
    private readonly errorHandlerService: ErrorHandlerService,
    public readonly commonService: CommonService,
    private readonly commonApiService: CommonApiService,
    private readonly hawbService: HawbService,
    private readonly modalService: ModalService,
    private readonly router: Router,
    private readonly formService: ValidatorService,
    private readonly accountsPayableService: AccountsPayableService,
    private readonly selectionService: SelectionService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly manifestService: ManifestService
  ) {
    this.confirmValue = '';
  }

  ngOnInit(): void {
    this.messagePopupData = this.data;
    this.initManifestPublishPopupState();
    this.initDuplicateChargeState();
    this.initInvoiceDatePromptState();

    // Initialize range options if provided
    if (
      this.messagePopupData.code?.rangeOptions &&
      this.messagePopupData.code.rangeOptions.length > 0
    ) {
      this.rangeOptions = this.messagePopupData.code.rangeOptions;
      // Select all ranges by default
      for (const [index] of this.rangeOptions.entries()) {
        this.selectedRanges.add(index);
      }
      this.selectAllRanges = true;
    }

    // Initialize filtered emails for autocomplete
    this.filteredEmails = this.emailCtrl.valueChanges.pipe(
      startWith(''),
      map((email: string | null) => {
        if (!email?.trim()) {
          return this.allEmails.filter(e => !this.selectedEmails.includes(e));
        }
        return this._filter(email);
      }),
      takeUntilDestroyed(this.destroyRef)
    );

    if (this.messagePopupData.code?.isForSendInvoiceViaEmail) {
      this.fetchUserEmails();
      this.loadCurrentUserEmailFromStorage();
      this.fetchInvoiceFileFormats();
      this.generateEmailSubjectAndBody();
      this.fetchAccountDetailsForInvoiceEmail();
    }
    if (this.messagePopupData.code?.isApTpGpConfirmation) {
      this.publsihConfirmationText();
    }
    this.startConfirmCountdown();
    this.shipmentGatewayPieceGridColumns =
      this.messagePopupData.code?.tableColumnConfig;
    this.shipmentGatewayPieceTableData =
      this.messagePopupData.code?.tableColumnDataSource;
    this.page = this.messagePopupData.code?.isFrom;
    this.masterShipmentTableColumnConfig =
      this.messagePopupData.code?.tableColumns;
    this.masterShipmentTableData = this.messagePopupData.code?.tableData;
    this.shipmentBagGridColumns =
      this.messagePopupData.code?.tableBagColumnConfig;
    this.shipmentBagPieceTableData =
      this.messagePopupData.code?.tableBagColumnDataSource;
    this.numberRangeDetailsGridColumns =
      this.messagePopupData.code?.tableColumnConfig;
    this.numberRangeDetailsTableData =
      this.messagePopupData.code?.tableColumnDataSource;
    this.apChargeCodeDetailsGridColumns =
      this.messagePopupData.code?.tableColumnConfig;
    this.apChargeCodeDetailsTableData =
      this.messagePopupData.code?.tableColumnDataSource;
    this.tableisFrom = this.messagePopupData.code?.tableIsFrom;
    this.confirmValue =
      this.messagePopupData.code?.isForCreateLinkedAccount ||
        this.messagePopupData.code?.isForCreateLinkedAccountFromInfoPage
        ? this.messagePopupData.code?.linkedAccountNumber
        : '';
    this.fullmanFileErrorLogMessages = this.messagePopupData.code?.errorLogData;
    this.autoRateFailedErrorMessage = this.messagePopupData.code?.errorLogData;
    this.apFileErrorLogMessages = this.messagePopupData.code?.errorLogData;
    this.autoRatingMessage = this.messagePopupData.code?.autoRatingMessage || '';
    this.autoRatingFailureDetailHeader = (
      this.messagePopupData.code?.autoRatingFailureDetailHeader ?? ''
    )
      .toString()
      .trim();
    this.errorLogSuccessMessage =
      this.messagePopupData.code?.errorLogSuccessMessage ?? '';
    this.autoRatingPreListCaption = (
      this.messagePopupData.code?.autoRatingPreListCaption ?? ''
    )
      .toString()
      .trim();
    this.scanBagShipmentGridColumns =
      this.messagePopupData.code?.tableScanShipmentBagColumnConfig;
    this.scanShipmentBagTableData =
      this.messagePopupData.code?.tableScanShipmentBagColumnDataSource;
    if (this.messagePopupData.code?.isForMultipleBagSelection) {
      this.multiBagSelectionGridColumns =
        this.messagePopupData.code?.tableColumnConfig;
      this.multiBagSelectionTableData =
        this.messagePopupData.code?.tableColumnDataSource;
      this.page = this.messagePopupData.code?.isFrom;
    }
    if (this.messagePopupData.code?.isForAPInvoiceFetchFromSFTP) {
      this.apSftpFilesGridColumns = apSftpFilesGridColumnConfig;
      this.selectionService.clear();
      this.areSelectedAgentsUniform = true;
      this.selectedAgentData = null;
      this.fetchApSftpFiles();
    }
    if (this.messagePopupData.code?.isForApChargesSelection) {
      this.selectionService.clear();
    }
    if (this.messagePopupData.code?.isForArChargesSelection) {
      this.selectionService.clear();
      this.hasNotAutoRatedSelection = false;
    }
    if (this.messagePopupData.code?.isForAssociateUfoShipments) {
      this.selectionService.clear();
      this.ufoShipmentsGridColumns = ufoShipmentsGridColumnsConfig;
      this.ufoShipmentsSearchPayload = {
        paging: { ...defauthawbPagination },
        searchText: ''
      };
      this.ufoFilterStartDate = null;
      this.ufoFilterEndDate = null;
      this.ufoFilterShipperConsignee = '';
      this.ufoAccountCtrl.setValue('');
      this.ufoSelectedAccount = null;
      this.setupUfoAccountAutocomplete();
      this.fetchAccountDetails();
      this.fetchUFOShipments();
    }
    if (this.messagePopupData.code?.isForMultiPieceShortageGrid) {
      this.selectionService.clear();
      this.multiPieceGatewayComments = '';
      this.multiPieceSelectionMismatchText = '';
    }
    if (this.messagePopupData.code?.isSendCBPClearance) {
      this.messageText = CBPConstantMessages.masterShipmentWarning;
      this.initialiseClearanceSelections();
    }
    this.eventDescriptionData =
      this.messagePopupData.code?.eventDescriptionData;
    if (this.messagePopupData.code?.forCopyRateScale) {
      this.createForm();
    }
    if (this.messagePopupData.code?.isForArInvoiceDownload) {
      this.fileType = arInvoicefileNameExtension.pdf;
    }
    this.initPopupGridConfigs();
  }

  private initPopupGridConfigs(): void {
    const code = this.messagePopupData?.code;
    if (!code) {
      return;
    }

    if (code.renderTable) {
      const gatewayMode = code.isForMultiPieceShortageGrid
        ? pageType.shipmentGatewayPieceShortage
        : this.page;
      this.gatewayRenderTableGridConfig = buildMessagePopupGridConfig({
        columns: this.shipmentGatewayPieceGridColumns ?? [],
        rowIdField: resolveMessagePopupRowIdField(gatewayMode),
        entityName: 'Shipments',
        storageKey: resolveMessagePopupStorageKey(gatewayMode),
        selection: !!code.isForMultiPieceShortageGrid,
        gatewayMode: code.isForMultiPieceShortageGrid ? undefined : gatewayMode,
        includeActionsColumn: !code.isForMultiPieceShortageGrid,
        rowSelectionDisabledFn: code.isForMultiPieceShortageGrid
          ? (row: any) =>
              row?.isGatewayed === popupButtons.Yes || row?.isPlaceholderRow
          : undefined,
      });
    }

    if (code.isForArChargesSelection) {
      this.arChargesGridConfig = buildMessagePopupGridConfig({
        columns: this.apChargeCodeDetailsGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Shipments',
        storageKey: GridColumnsStorageNames.arMultiShipmentSelection,
        selection: true,
      });
    }

    if (code.renderMasterShipmentTable) {
      this.masterShipmentGridConfig = buildMessagePopupGridConfig({
        columns: this.masterShipmentTableColumnConfig ?? [],
        rowIdField: resolveMessagePopupRowIdField(this.tableisFrom),
        entityName: 'Shipments',
        storageKey: resolveMessagePopupStorageKey(this.tableisFrom),
        gatewayMode: pageType.shipmentGatewayMasterShipment,
      });
    }

    if (code.renderBagShipmentTable) {
      this.bagShipmentGridConfig = buildMessagePopupGridConfig({
        columns: this.shipmentBagGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Shipments',
        storageKey: GridColumnsStorageNames.shipmentBag,
        gatewayMode: pageType.shipmentBag,
      });
    }

    if (code.renderBagScanShipmentTable) {
      this.scanBagShipmentGridConfig = buildMessagePopupGridConfig({
        columns: this.scanBagShipmentGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Shipments',
        storageKey: GridColumnsStorageNames.shipmentBag,
        gatewayMode: pageType.scanShipmentBag,
      });
    }

    if (code.isForMultipleBagSelection) {
      this.multiBagSelectionGridConfig = buildMessagePopupGridConfig({
        columns: this.multiBagSelectionGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Bags',
        storageKey: GridColumnsStorageNames.manifestMultipleBagSelection,
        gatewayMode: pageType.manifestMultipleBagSelection,
      });
    }

    if (code.renderRangesDetailTable) {
      this.numberRangeGridConfig = buildMessagePopupGridConfig({
        columns: this.numberRangeDetailsGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Ranges',
        storageKey: GridColumnsStorageNames.smNumberRanges,
      });
    }

    if (code.apChargeCodeDetailTable) {
      this.apChargeDetailGridConfig = buildMessagePopupGridConfig({
        columns: this.apChargeCodeDetailsGridColumns ?? [],
        rowIdField: 'id',
        entityName: 'Charge Codes',
        storageKey: GridColumnsStorageNames.apChargesCodeDetail,
      });
    }

    if (code.isForLinkedAccounts && code.isForRenderingTable) {
      this.linkedAccountsGridConfig = buildMessagePopupGridConfig({
        columns: code.tableColumns ?? [],
        rowIdField: 'id',
        entityName: 'Accounts',
        storageKey: GridColumnsStorageNames.linkedAccounts,
        hyperlinkKeys: ['details'],
      });
    }

    if (code.isForAssociateUfoShipments) {
      this.ufoShipmentsGridConfig = buildMessagePopupGridConfig({
        columns: this.ufoShipmentsGridColumns ?? [],
        rowIdField: 'hawbId',
        entityName: 'Shipments',
        storageKey: GridColumnsStorageNames.associateUfoShipments,
        selection: true,
        pagination: true,
      });
    }

    if (code.isForAPInvoiceFetchFromSFTP) {
      this.apSftpFilesGridConfig = buildMessagePopupGridConfig({
        columns: this.apSftpFilesGridColumns ?? [],
        rowIdField: 'fileName',
        entityName: 'Files',
        storageKey: GridColumnsStorageNames.apSftpFiles,
        selection: true,
      });
    }
  }

  public onPopupGatewayRowAction(event: { row: any; action: string }): void {
    const code = this.messagePopupData.code;
    const { row, action } = event;

    if (
      code?.renderBagShipmentTable ||
      code?.renderBagScanShipmentTable ||
      code?.isForMultipleBagSelection
    ) {
      if (action === popupButtons.Select) {
        this.proccedAndCloseMasterShipmentSelection(row);
      }
      return;
    }

    if (code?.renderMasterShipmentTable && action === popupButtons.proceed) {
      this.proccedAndCloseMasterShipmentSelection(row);
      return;
    }

    if (
      code?.renderTable &&
      !code?.isForMultiPieceShortageGrid &&
      (action === popupButtons.proceed ||
        action === popupButtons.createLinkedShipments ||
        action === popupButtons.gateway ||
        action === popupButtons.create)
    ) {
      this.proccedAndCloseMasterShipmentSelection({
        selectedButton: action,
        selectedData: row,
      });
    }
  }

  public onPopupLinkedAccountRowClick(event: { row: any }): void {
    this.navigateToSpecificRecord(event.row);
  }

  public onManifestAttachmentDelete(row: {
    displayName: string;
    storedFileName: string;
  }): void {
    this.onManifestAttachmentNavigate({ action: 'deleteAttachment', row });
  }

  private initManifestPublishPopupState(): void {
    const code = this.messagePopupData?.code;
    if (!code?.isForPublishTicketCheckbox) {
      return;
    }
    this.isCheckboxChecked = true;
    if (code.agentId != null) {
      this.fetchManifestPublishFormats(code.agentId);
    }
    this.loadCurrentUserEmailFromStorage();
  }

  public getConfirmText() {
    return this.messagePopupData.code?.isApTpGpConfirmation
      ? this.messagePopupData.code?.confirmText
      : '';
  }

  // SPEC-BUX-001 FR-BUX-001/002: these confirmations no longer ask the user to
  // type a phrase; the confirm button unlocks after a short countdown instead.
  private isCountdownConfirmation(): boolean {
    const code = this.messagePopupData.code;
    return !!(
      code?.isMultiple ||
      code?.isForBulkBagConfirmation ||
      code?.isForBulkGateway ||
      code?.isBulkManifestconfirmation ||
      code?.isBulkMawbConfirmation ||
      code?.isAutoSync ||
      code?.isForSuperAdminCbpConfirm ||
      code?.isForSpecialPermCbpConfirm
    );
  }

  private startConfirmCountdown(): void {
    if (!this.isCountdownConfirmation()) {
      return;
    }
    this.confirmCountdown = confirmCountdownSeconds;
    timer(1000, 1000)
      .pipe(take(confirmCountdownSeconds), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.confirmCountdown--);
  }

  public getCancelButtonName() {
    // Opt-in override (SPEC-CRS-001-v1.0 FR-050 / FR-052). Absent for every
    // existing caller, so their labels are unchanged.
    if (this.messagePopupData.code?.dismissButtonLabel) {
      return this.messagePopupData.code.dismissButtonLabel;
    }
    if (this.messagePopupData.code?.isForSummaryPageCurrentPageExportWarning) {
      return popupButtons.Cancel;
    }
    if (this.messagePopupData.code?.isBulkEditEligibilityPartial) {
      return popupButtons.No;
    }
    if (this.messagePopupData.code?.isForArInvoiceWeightUpdate) {
      return popupButtons.No;
    }
    let buttonName = popupButtons.Cancel;
    if (
      this.messagePopupData.code?.isMultiple ||
      this.messagePopupData.code?.isForDownload ||
      this.messagePopupData.code?.isForArInvoiceDownload ||
      this.messagePopupData.code?.isForSearch ||
      this.messagePopupData.code?.isForPublish ||
      this.messagePopupData.code?.isForPrint ||
      this.messagePopupData.code?.renderTable ||
      this.messagePopupData.code?.isForBulkGateway ||
      this.messagePopupData.code?.isForBulkBagConfirmation ||
      this.messagePopupData.code?.renderTable ||
      this.messagePopupData.code?.isForGatewayLocationMismatch ||
      this.messagePopupData.code?.isForCbpFail ||
      this.messagePopupData.code?.isForBagCbpFail ||
      this.messagePopupData.code?.renderBagShipmentTable ||
      this.messagePopupData.code?.isForHandlingExisitingAccount ||
      this.messagePopupData.code?.renderBagShipmentTable ||
      this.messagePopupData.code?.isForCreateLinkedAccount ||
      this.messagePopupData.code?.isForErrorLog ||
      this.messagePopupData.code?.isForCbpStatusDescriptionLog ||
      this.messagePopupData.code?.isSendCBPClearance ||
      this.messagePopupData.code?.isSendPartialValidate ||
      this.messagePopupData.code?.isBulkManifestconfirmation ||
      this.messagePopupData.code?.isSendPartialValidate ||
      this.messagePopupData.code?.isForNumberRange ||
      this.messagePopupData.code?.isBulkMawbConfirmation ||
      this.messagePopupData.code?.isForCreateLinkedAccountFromInfoPage ||
      this.messagePopupData.code?.isForSendInvoiceViaEmail ||
      this.messagePopupData.code?.isForProceedChanges ||
      this.messagePopupData.code?.isForAgentChange ||
      this.messagePopupData.code?.isForCreateLinkedAccountFromInfoPage ||
      this.messagePopupData.code?.isForUploadInvoiceForAp ||
      this.messagePopupData.code?.forCopyRateScale ||
      this.messagePopupData.code?.isForAPErrorLog ||
      this.messagePopupData.code?.isForAPInvoiceFetchFromSFTP ||
      this.messagePopupData.code?.isForAPErrorLog ||
      this.messagePopupData.code?.isApTpGpConfirmation ||
      this.messagePopupData.code?.isApToGpPublishFormSummary ||
      this.messagePopupData.code?.renderBagScanShipmentTable ||
      this.messagePopupData.code?.autoRateFromHawbSummary ||
      this.messagePopupData.code?.isAutoSync ||
      this.messagePopupData.code?.isApChargeDuplicateEntry ||
      this.messagePopupData.code?.isForArChargesSelection ||
      this.messagePopupData.code?.isForMultipleBagSelection ||
      this.messagePopupData.code?.isForAssociateUfoShipments ||
      this.messagePopupData.code?.isForSuperAdminCbpConfirm ||
      this.messagePopupData.code?.isForSpecialPermCbpConfirm
    ) {
      buttonName = popupButtons.Cancel;
    } else if (this.messagePopupData.code?.isForDiscardChanges) {
      buttonName = popupButtons.ContinueEdit;
    } else if (this.messagePopupData.code?.isForServiceTypeWarning) {
      buttonName = popupButtons.GoBack;
    } else if (
      this.messagePopupData.code?.isForAccountServiceTypeDelinkConfirmation
    ) {
      buttonName = popupButtons.Cancel;
    } else if (this.messagePopupData.code?.isForCommodityDiscardChanges) {
      buttonName = popupButtons.DiscardToSaveCommunity;
    } else if (this.messagePopupData.code?.isForRolesPermissionsImpactedUsers) {
      buttonName = popupButtons.discardChanges;
    } else if (this.messagePopupData.code?.isRoleDuplicate) {
      buttonName = popupButtons.discardCreation;
    } else if (this.messagePopupData.code?.isWeightCheck) {
      buttonName = popupButtons.retainExisting;
    } else if (this.messagePopupData.code?.statusCodeDiscardChanges) {
      buttonName = popupButtons.cancelEdit;
    } else if (!this.messagePopupData.code?.isMultiple) {
      buttonName = popupButtons.No;
      if (this.messagePopupData.code?.isOptionalTextbox) {
        buttonName = popupButtons.Cancel;
      }
    }
    return buttonName;
  }

  public confirm() {
    const code = this.messagePopupData.code;

    if (!code) {
      this.ref.close(true);
      return;
    }
    if (code.isForAccountServiceTypeDelinkConfirmation) {
      this.ref.close({ confirmServiceTypeDelink: true });
      return;
    }
    const shouldAbort = this.processConfirmCode(code);
    if (shouldAbort) {
      return;
    }
    if (code.autoRateFromHawbSummary) {
      this.ref.close({
        action: this.messagePopupData.code?.isForSpecialServiceCheck
          ? AutoRateFeatureKeys.createInvoice
          : AutoRateFeatureKeys.proceed,
        popupClose: true,
      });
      return;
    }
    if (code.isForServiceTypeWarning) {
      this.ref.close({ goAhead: true });
    }
  }

  private shouldCloseWithComment(code: any): boolean {
    return !code.isMultiple && code.isOptionalTextbox;
  }

  private shouldValidateAccountNumber(code: any): boolean {
    return (
      code.isForCreateLinkedAccount || code.isForCreateLinkedAccountFromInfoPage
    );
  }

  private shouldCloseWithFileType(code: any): boolean {
    return !code.isMultiple && (code.isForDownload || code.isForArInvoiceDownload);
  }

  public toggleSelectAllRanges(): void {
    if (this.selectAllRanges) {
      // Select all ranges
      for (const [index] of this.rangeOptions.entries()) {
        this.selectedRanges.add(index);
      }
    } else {
      // Deselect all ranges
      this.selectedRanges.clear();
    }
  }

  private initDuplicateChargeState(): void {
    const arr = this.messagePopupData?.code?.duplicateDetails || [];

    this.duplicateList = arr.map((row: any) => ({
      id: row.indexedId,
      ...row,
    }));

    this.isDuplicateMulti = this.duplicateList.length > 1;
  }

  public selectSingleDuplicate(action: string): void {
    this.singleDuplicateAction = action;
    const firstId = this.duplicateList[0]?.id;
    if (firstId !== undefined && firstId !== null) {
      this.duplicateSelection.set(firstId, action);
    }
  }

  public selectDuplicateFor(id: any, action: string): void {
    this.duplicateSelection.set(id, action);
  }

  public markAllDuplicates(action: string): void {
    this.duplicateSelection.clear();
    this.duplicateList.forEach(d => this.duplicateSelection.set(d.id, action));
    if (this.isDuplicateMulti) {
      this.multiDuplicateAction = action;
    } else {
      this.singleDuplicateAction = action;
    }
  }

  public undoAllDuplicates(): void {
    this.duplicateSelection.clear();
    this.multiDuplicateAction = null;
  }

  public isDuplicateConfirmDisabled(): boolean {
    if (!this.messagePopupData?.code?.isApChargeDuplicateEntry) return false;
    return this.isDuplicateMulti
      ? this.duplicateSelection.size !== this.duplicateList.length
      : !this.singleDuplicateAction;
  }

  public confirmDuplicateSelection(): void {
    const allowIds: any = [];
    const removeIds: any = [];

    this.duplicateSelection.forEach((v, id) => {
      if (v === popupConditions.allow) allowIds.push(id);
      if (v === popupConditions.remove) removeIds.push(id);
    });

    this.ref.close({ popupClose: true, allowIds, removeIds });
  }

  public onDuplicateCancel(): void {
    if (this.messagePopupData?.code?.isApChargeDuplicateEntry) {
      this.duplicateSelection.clear();
      this.singleDuplicateAction = null;
      this.multiDuplicateAction = null;
      this.ref.close({ popupClose: false });
    }
  }

  public toggleRangeSelection(index: number): void {
    if (this.selectedRanges.has(index)) {
      this.selectedRanges.delete(index);
    } else {
      this.selectedRanges.add(index);
    }
    // Update select all checkbox state
    this.selectAllRanges =
      this.selectedRanges.size === this.rangeOptions.length;
  }

  public isRangeSelected(index: number): boolean {
    return this.selectedRanges.has(index);
  }

  public isDownloadEnabled(): boolean {
    // Check if file type is selected
    if (!this.fileType) {
      return false;
    }
    if (this.messagePopupData.code?.isForArInvoiceDownload) {
      return true;
    }
    // If ranges are present, check if at least one is selected
    if (this.rangeOptions && this.rangeOptions.length > 0) {
      return this.selectedRanges.size > 0;
    }
    // No ranges present, download is enabled if file type is selected
    return true;
  }

  /** @deprecated Legacy CBP partial submit — Customs City uses single processClearance call. */
  private shouldSendCBPClearance(code: any): boolean {
    return !code.isMultiple && code.isPartiallyFailedCBP;
  }

  private handleCopyRateScale(): void {
    this.copyRateScaleForm.markAllAsTouched();
    if (this.copyRateScaleForm.valid && this.onConfirm) {
      this.onConfirm(this.copyRateScaleForm.value);
    }
  }

  public navigateToSpecificRecord(event: any) {
    if (this.messagePopupData.code?.isForLinkedAccounts) {
      this.router.navigate(['/sm-dashboard/account/account-information'], {
        queryParams: {
          mode: ActionIcons.view,
          id: event.id,
        },
      });
      this.ref.close(true);
    }
  }

  public closePopup(event?: string) {
    if (this.messagePopupData.code?.isForUserCreate && !event) {
      this.ref.close({ email: '', popupClose: true, clickedIcon: false });
    } else if (
      (this.messagePopupData.code?.isAddHawb && event) ||
      (this.messagePopupData.code?.isRoleDuplicate && event)
    ) {
      this.ref.close('close');
    } else if (this.messagePopupData.code?.isForCommodityDiscardChanges) {
      this.hawbService.setCommoditySavedStatus(true);
      this.ref.close(false);
    } else if (this.messagePopupData.code?.isForServiceTypeWarning) {
      this.ref.close({ goAhead: false });
    } else if (
      this.messagePopupData.code?.isForAccountServiceTypeDelinkConfirmation
    ) {
      this.ref.close({ confirmServiceTypeDelink: false });
    } else if (this.messagePopupData.code?.isArAdditionalChargesModal) {
      this.ref.close(null);
    } else if (event === 'close') {
      this.ref.close(undefined);
    } else {
      this.ref.close(false);
    }
    if (this.messagePopupData.code?.isForApChargesSelection) {
      this.selectionService.clear();
    }
    if (this.messagePopupData.code?.isForArChargesSelection) {
      this.selectionService.clear();
    }
    if (this.messagePopupData.code?.isForMultiPieceShortageGrid) {
      this.selectionService.clear();
    }
  }

  public editShipment() {
    this.ref.close(popupButtons.editShipment);
  }

  public isValidMultiPiecePhysicalCount(): boolean {
    const count = Number.parseInt(this.multiPiecePhysicalCountInput, 10);
    return Number.isInteger(count) && count >= 1;
  }

  private getMultiPiecePhysicalCountValue(): number | null {
    const count = Number.parseInt(this.multiPiecePhysicalCountInput, 10);
    return Number.isInteger(count) && count >= 1 ? count : null;
  }

  private getMultiPieceRecordedPieceCount(): number {
    return this.messagePopupData.code?.recordedPieceCount ?? 0;
  }

  /** SPEC-OCS-001 FR-007: physical > recorded is informational; Gateway stays enabled. */
  public getMultiPieceOverageInfoText(): string {
    const entered = this.getMultiPiecePhysicalCountValue();
    const recorded = this.getMultiPieceRecordedPieceCount();
    if (entered == null || recorded < 1 || entered <= recorded) {
      return '';
    }
    return ModalPopupMessages.multiPieceGatewayOverageInfo(entered - recorded);
  }

  public isMultiPieceGatewayConfirmDisabled(): boolean {
    return !this.isValidMultiPiecePhysicalCount();
  }

  public getMultiPieceShortageHint(): string {
    const count = this.messagePopupData.code?.physicalPieceCount ?? 0;
    return ModalPopupMessages.multiPieceShortageSelectionHint(count);
  }

  private isMultiPieceShortageSubmitDisabled(): boolean {
    const expected = this.messagePopupData.code?.physicalPieceCount ?? 0;
    return (
      this.selectionService.size() === 0 ||
      this.selectionService.size() !== expected
    );
  }

  public onMultiPieceShortageSelectionChange(): void {
    const expected = this.messagePopupData.code?.physicalPieceCount ?? 0;
    const selected = this.selectionService.size();
    if (selected > 0 && selected !== expected) {
      this.multiPieceSelectionMismatchText =
        ModalPopupMessages.multiPieceSelectionMismatch(expected, selected);
    } else {
      this.multiPieceSelectionMismatchText = '';
    }
  }

  public getPopupButtonLabel(): string {
    const code = this.messagePopupData.code;

    // Opt-in override (SPEC-CRS-001-v1.0 FR-050 / FR-052). Absent for every
    // existing caller, so their labels are unchanged.
    if (code?.confirmButtonLabel) {
      return code.confirmButtonLabel;
    }

    // Handle special cases first
    if (this.isDeleteOrSearchAction(code)) {
      return this.popupButtons.Delete;
    }

    if (this.isOptionalTextboxAction(code)) {
      return code.isBlock;
    }

    if (this.isNumberRangeAction(code)) {
      return code.buttonName;
    }

    // Use button mapping for standard cases
    const buttonMapping = this.getButtonMapping();

    for (const [condition, buttonLabel] of buttonMapping) {
      if (condition(code)) {
        return buttonLabel;
      }
    }

    return this.popupButtons.Yes;
  }

  private isDeleteOrSearchAction(code: any): boolean {
    return code?.isMultiple || code?.isForSearch;
  }

  private isOptionalTextboxAction(code: any): boolean {
    return !code?.isMultiple && code?.isOptionalTextbox;
  }

  private isNumberRangeAction(code: any): boolean {
    return code?.isForNumberRange;
  }

  private isBulkAction(code: any): boolean {
    return (
      code?.isForBulkGateway ||
      code?.isForBulkBagConfirmation ||
      code?.isBulkManifestconfirmation ||
      code?.isBulkMawbConfirmation ||
      code?.isApTpGpConfirmation ||
      code?.isAutoSync
    );
  }

  private isTableRenderAction(code: any): boolean {
    return (
      (code?.renderTable && !code?.isForMultiPieceShortageGrid) ||
      code?.renderBagShipmentTable ||
      code?.renderBagScanShipmentTable
    );
  }

  private isLinkedAccountAction(code: any): boolean {
    return (
      code?.isForCreateLinkedAccount ||
      code?.isForCreateLinkedAccountFromInfoPage
    );
  }

  private getButtonMapping(): Array<[(code: any) => boolean, string]> {
    return [
      [code => code?.isForArInvoiceWeightUpdate, this.popupButtons.Yes],
      [
        code => code?.isForAccountServiceTypeDelinkConfirmation,
        this.popupButtons.Confirm,
      ],
      [code => code?.isForServiceTypeWarning, this.popupButtons.GoAhead],
      [code => code?.isForApChargesSelection, this.popupButtons.proceed],
      [code => code?.isForArChargesSelection, this.popupButtons.proceed],
      [code => code?.isApChargeDuplicateEntry, this.popupButtons.Confirm],
      [code => code?.isForDiscardChanges, this.popupButtons.Discard],
      [
        code => code?.isForCommodityDiscardChanges,
        this.popupButtons.proceedShipmentSave,
      ],
      [code => code?.isForMultiPieceGatewayConfirm, this.popupButtons.gateway],
      [code => code?.isForMultiPieceShortageGrid, this.popupButtons.gatewayReceivedShipments],
      [code => this.isTableRenderAction(code), this.popupButtons.Ok],
      [code => this.isBulkAction(code), this.popupButtons.Confirm],
      [code => code?.isForGatewayLocationMismatch, this.popupButtons.gateway],
      [code => code?.isForBagCbpFail, this.popupButtons.proceedWithBagGateway],
      [code => code?.isForCbpFail, this.popupButtons.proceedWithGateway],
      [code => code?.isForSuperAdminCbpConfirm, this.popupButtons.Confirm],
      [code => code?.isForSpecialPermCbpConfirm, this.popupButtons.Confirm],
      [code => this.isLinkedAccountAction(code), this.popupButtons.create],
      [
        code => code?.isForRolesPermissionsImpactedUsers,
        this.popupButtons.updateExistingUsers,
      ],
      [code => code?.isRoleDuplicate, this.popupButtons.editInformation],
      [code => code?.isSendCBPClearance, this.popupButtons.sendForClearance],
      [code => code?.isWeightCheck, this.popupButtons.changeExisting],
      [code => code?.statusCodeDiscardChanges, this.popupButtons.GoAhead],
      [code => code?.isForSendInvoiceViaEmail, this.popupButtons.sendEmail],
      [code => code?.isForInvoiceDatePrompt, this.popupButtons.proceed],
      [code => code?.isForProceedChanges, this.popupButtons.proceed],
      [code => code?.forCopyRateScale, this.popupButtons.copyRateScale],
      [code => code?.isForAgentChange, this.popupButtons.Continue],
      [
        code => code?.isForAPInvoiceFetchFromSFTP,
        this.popupButtons.createAPInvoice,
      ],
      [code => code?.isApToGpPublishFormSummary, this.popupButtons.Confirm],
      [code => code?.isForSpecialServiceCheck, this.popupButtons.createInvoice],
      [code => code?.isAutoSync, this.popupButtons.Confirm],
      [code => code?.isForMultipleBagSelection, this.popupButtons.Select],
      [code => code?.isForAssociateUfoShipments, this.popupButtons.proceed],
      [
        code => code?.isForSummaryPageCurrentPageExportWarning,
        this.popupButtons.proceed,
      ],
    ];
  }

  public resetUfoFilter(): void {
    this.ufoFilterStartDate = null;
    this.ufoFilterEndDate = null;
    this.ufoFilterShipperConsignee = '';
    this.applyUfoFiltersToTableData();
  }

  private initInvoiceDatePromptState(): void {
    const code = this.messagePopupData?.code;
    if (!code?.isForInvoiceDatePrompt) {
      return;
    }
    this.invoiceDatePromptValue = code.defaultInvoiceDate ?? new Date();
    this.invoiceDatePromptMinDate = code.invoiceDateMin ?? null;
    this.invoiceDatePromptMaxDate = code.invoiceDateMax ?? null;
  }

  private handleInvoiceDatePrompt(code: any): boolean | null {
    if (!code?.isForInvoiceDatePrompt) {
      return null;
    }
    if (!this.invoiceDatePromptValue) {
      return true;
    }
    this.ref.close({
      popupClose: true,
      invoiceDate: this.invoiceDatePromptValue,
    });
    return false;
  }

  public onUfoFiltersChanged(): void {
    this.applyUfoFiltersToTableData();
  }

  private applyUfoFiltersToTableData(): void {
    this.ufoShipmentsTableData = this.filterUfoShipmentsLocally(
      this.ufoShipmentsRawData
    );
  }

  public onUfoShipmentsSelectionChange(): void {
    this.cdRef.detectChanges();
  }

  public onUfoShipmentsPageChange(event: PageEvent): void {
    updateZeroBasedPagingPayload(this.ufoShipmentsSearchPayload.paging, event);
    this.fetchUFOShipments();
  }

  public isButtonDisabled(): boolean {
    const code = this.messagePopupData.code;
    const conditions = [
      {
        check: code?.isForInvoiceDatePrompt,
        value: !this.invoiceDatePromptValue,
      },
      { check: code?.renderBagShipmentTable, value: !this.selectedRowData },
      {
        check: code?.isForCreateLinkedAccount,
        value: !this.isConfirmValueValid,
      },
      {
        check: code?.isForCreateLinkedAccountFromInfoPage,
        value: !this.isConfirmValueValid,
      },
      { check: code?.isForUserCreate, value: !this.isConfirmValueValid },
      {
        check: code?.isSendCBPClearance,
        value:
          !this.selectedClearanceTypeCode ||
          this.isCustomsCityClearanceSubmitting,
      },
      {
        check: code?.isForAPInvoiceFetchFromSFTP,
        value: this.isAPInvoiceSFTPDisabled(),
      },
      { check: code?.renderBagScanShipmentTable, value: !this.selectedRowData },
      { check: code?.isForMultipleBagSelection, value: !this.selectedRowData },
      {
        check: code?.isForApChargesSelection,
        value: this.selectionService.size() === 0,
      },
      {
        check: code?.isForSendInvoiceViaEmail,
        value: this.isSendInvoiceEmailDisabled(),
      },
      {
        check: code?.isForArChargesSelection,
        value: this.selectionService.size() === 0 || this.hasNotAutoRatedSelection,
      },
      {
        check: code?.isForAssociateUfoShipments,
        value:
          this.selectionService.size() === 0 ||
          !this.hasUfoAccountForProceed(),
      },
      {
        check: code?.isForMultiPieceGatewayConfirm,
        value: this.isMultiPieceGatewayConfirmDisabled(),
      },
      {
        check: code?.isForMultiPieceShortageGrid,
        value: this.isMultiPieceShortageSubmitDisabled(),
      },
      {
        check: code?.isForPublishTicketCheckbox,
        value: this.isManifestPublishDisabled(),
      },
    ];
    for (const c of conditions) {
      if (c.check && c.value) {
        return true;
      }
    }
    return (
      this.getClassValueForEnableDisable() ||
      (!code?.isMultiple && code?.isOptionalTextbox && !this.confirmValue)
    );
  }

  private isAPInvoiceSFTPDisabled(): boolean {
    if (this.selectionService.size() === 0) {
      return true;
    }
    if (!this.areSelectedAgentsUniform) {
      return true;
    }
    return false;
  }

  private isSendInvoiceEmailDisabled(): boolean {
    return (
      this.selectedEmails.length === 0 ||
      !this.emailSubject?.trim() ||
      this.selectedFileFormats.length === 0
    );
  }

  public proccedAndCloseMasterShipmentSelection(selectedShipmentData: any) {
    this.selectedRowData = selectedShipmentData;
    if (this.messagePopupData.code?.renderMasterShipmentTable) {
      this.ref.close({
        popupClose: true,
        masterShipmentData: selectedShipmentData,
      });
    } else if (this.messagePopupData.code?.renderTable) {
      this.ref.close({
        popupClose: true,
        selectedShipmentData: selectedShipmentData,
      });
    }
  }

  public normalizeText(text: string): string {
    return text.toLowerCase().replace(/\s+/g, '');
  }

  public validateConfirmValue(): void {
    if (this.messagePopupData.code?.isForCreateLinkedAccount) {
      const confirmValue = String(this.confirmValue);
      if (!confirmValue || confirmValue.length !== 7) {
        this.snakbarService.openCustomisedSnackBar(
          LinkedAccountConstants.wrongAccountNumber,
          ModalPopupMessages.Warning
        );
        this.isConfirmValueValid = false;
        return;
      }
      if (confirmValue.endsWith('00')) {
        this.snakbarService.openCustomisedSnackBar(
          LinkedAccountConstants.linkedAccountNotEndWith0,
          ModalPopupMessages.Warning
        );
        this.isConfirmValueValid = false;
        return;
      }
      this.isConfirmValueValid = true;
    } else if (this.messagePopupData.code?.isForUserCreate) {
      const confirmValue = String(this.confirmValue).trim();
      const emailRegex = ValidatorPattern.emailUserValidator; // Use the RegExp object
      if (!confirmValue) {
        this.isConfirmValueValid = true; // Empty confirmValue is valid
        return;
      }
      if (!emailRegex.test(confirmValue)) {
        this.snakbarService.openCustomisedSnackBar(
          UserManagementConstants.invalidEmail,
          ModalPopupMessages.Warning
        );
        this.isConfirmValueValid = false;
        return;
      }
      this.isConfirmValueValid = true; // Valid email
    }
  }

  private get configuredClearanceTypes(): Array<'C' | 'E'> {
    return this.messagePopupData.code?.clearanceTypeCodes ?? [];
  }

  private initialiseClearanceSelections(): void {
    const configured = this.configuredClearanceTypes;
    this.selectedClearanceTypeCode =
      configured.length === 1 ? configured[0] : null;
  }

  public get isAcasSelected(): boolean {
    return this.acasSelectionOverride ?? this.isChannelConfigured('ACAS');
  }

  public isClearanceTypeLocked(code: 'C' | 'E'): boolean {
    const configured = this.configuredClearanceTypes;
    return !configured.includes(code) || configured.length === 1;
  }

  public isChannelConfigured(name: string): boolean {
    return (
      this.messagePopupData.code?.configuredClearanceChannels ?? []
    ).includes(name);
  }

  /** AMS is filed on every submission, so only a configured ACAS is editable. */
  public isChannelLocked(name: string): boolean {
    return name !== 'ACAS' || !this.isChannelConfigured('ACAS');
  }

  public isChannelChecked(name: string): boolean {
    return name === 'ACAS' ? this.isAcasSelected : true;
  }

  public onClearanceTypeChange(code: 'C' | 'E'): void {
    if (this.isClearanceTypeLocked(code)) {
      return;
    }
    this.selectedClearanceTypeCode =
      this.selectedClearanceTypeCode === code ? null : code;
  }

  public onClearanceChannelToggle(name: string, checked: boolean): void {
    if (this.isChannelLocked(name)) {
      return;
    }
    this.acasSelectionOverride = checked;
  }

  private validateAccountNumber(accountNumber: string) {
    this.commonApiService
      .validateAccountNumber(accountNumber)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: any) => {
          if (data.statusCode === StatusCodes.Success) {
            this.ref.close({ popupClose: true, comments: this.confirmValue });
          } else if (data.statusCode === StatusCodes.SuccessfulRequest) {
            this.snakbarService.openCustomisedSnackBar(
              validationErrorMessages.accountAlreadyExist,
              ModalPopupMessages.Warning
            );
          }
        }
      });
  }

  public renderPlaceholder() {
    return this.messagePopupData.code?.isForUserCreate
      ? 'Enter Email ID'
      : 'Type here';
  }

  public emitArAdditionalChargesChoice(
    choice: ArAdditionalChargesChoiceValue
  ): void {
    this.ref.close({ popupClose: true, data: choice });
  }

  public handleFooterButtonActions(btnName: string) {
    if (btnName === 'Cancel') {
      this.ref.close();
    } else if (btnName === popupButtons.tryAnother) {
      this.ref.close({ popupClose: true, data: popupButtons.tryAnother });
    } else if (btnName === popupButtons.createLinkedAccount) {
      this.ref.close({
        popupClose: true,
        data: popupButtons.createLinkedAccount,
      });
    } else if (btnName === popupButtons.useSuggestedAccount) {
      this.ref.close({
        popupClose: true,
        data: popupButtons.useSuggestedAccount,
      });
    } else if (btnName === popupButtons.proceed) {
      this.ref.close({
        popupClose: true,
        data: this.selectedOption,
        checkboxValue: this.isCheckboxChecked,
      });
    } else if (btnName === popupButtons.sendCredentials) {
      this.ref.close({ popupClose: true, data: true });
    }
  }

  public isEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  public commentBoxChange(event: any) {
    const input = event.target as HTMLTextAreaElement;
    const trimmedValue = input.value.replace(
      ValidatorPattern.StartPositionSpaceNotAllowed,
      ''
    );
    if (input.value !== trimmedValue) {
      this.confirmValue = trimmedValue;
      input.value = trimmedValue;
    }
  }

  public getClassValueForEnableDisable() {
    return (
      this.confirmCountdown > 0 ||
      (this.messagePopupData.code?.isApTpGpConfirmation &&
        this.normalizeText(this.confirmValue) !==
        this.normalizeText(this.requiredPublishText))
    );
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  public triggerFileInput(event: Event): void {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  private buildClearancePayload(
    source: { ids?: number[]; isFrom?: string } | null | undefined
  ): CustomsCityProcessClearanceRequest | null {
    if (!source?.ids?.length || !source.isFrom || !this.selectedClearanceTypeCode) {
      return null;
    }

    return {
      ids: source.ids,
      isFrom: source.isFrom,
      clearanceTypeCode: this.selectedClearanceTypeCode,
      fileAcas: this.isAcasSelected,
    };
  }

  private submitCustomsCityClearance(): void {
    const payload = this.buildClearancePayload(
      resolveCustomsCityClearanceSelectionPayload(
        this.messagePopupData.code?.processClearancePayload,
        this.messagePopupData.code?.selectedIds,
        this.messagePopupData.code?.isFromModule
      )
    );
    if (!payload) {
      return;
    }

    this.isCustomsCityClearanceSubmitting = true;

    if (isCustomsCityClearanceChannelValidationModule(payload.isFrom)) {
      this.validateThenProcessCustomsCityClearance(payload);
      return;
    }

    this.executeProcessCustomsCityClearance(payload);
  }

  private validateThenProcessCustomsCityClearance(
    payload: CustomsCityProcessClearanceRequest
  ): void {
    this.commonService
      .validateCustomsCityClearance(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => this.handleCustomsCityChannelValidationResponse(resp),
        error: (error: HttpErrorResponse) => {
          this.isCustomsCityClearanceSubmitting = false;
          this.handleCustomsCityChannelValidationHttpError(error);
        },
      });
  }

  private handleCustomsCityChannelValidationResponse(
    resp: CustomsCityValidateCustomsCityClearanceResponse
  ): void {
    const statusCode = resp?.statusCode;

    if (statusCode === CustomsCityValidateChannelStatusCodes.AllEligible) {
      const processPayload = this.buildClearancePayload(
        resp.data?.processClearancePayload
      );
      if (!processPayload) {
        this.isCustomsCityClearanceSubmitting = false;
        return;
      }
      this.executeProcessCustomsCityClearance(processPayload);
      return;
    }

    if (
      statusCode === CustomsCityValidateChannelStatusCodes.PartialEligible &&
      resp.data?.requiresConfirmation === true
    ) {
      this.isCustomsCityClearanceSubmitting = false;
      this.openCustomsCityChannelPartialConfirmDialog(resp);
      return;
    }

    if (statusCode === CustomsCityValidateChannelStatusCodes.NoneEligible) {
      this.isCustomsCityClearanceSubmitting = false;
      this.snakbarService.openCustomisedSnackBar(
        resp.message,
        ModalPopupMessages.error
      );
      return;
    }

    this.isCustomsCityClearanceSubmitting = false;
    this.errorHandlerService.handleApiError(resp);
  }

  private handleCustomsCityChannelValidationHttpError(
    error: HttpErrorResponse
  ): void {
    const body = parseCustomsCityValidateCustomsCityClearanceResponse(
      error?.error
    );

    if (body?.statusCode === CustomsCityValidateChannelStatusCodes.NoneEligible) {
      this.snakbarService.openCustomisedSnackBar(
        body.message,
        ModalPopupMessages.error
      );
      return;
    }

    if (
      body?.statusCode === CustomsCityValidateChannelStatusCodes.PartialEligible &&
      body.data?.requiresConfirmation === true
    ) {
      this.openCustomsCityChannelPartialConfirmDialog(body);
      return;
    }

    this.errorHandlerService.handleError(error);
  }

  private openCustomsCityChannelPartialConfirmDialog(
    resp: CustomsCityValidateCustomsCityClearanceResponse
  ): void {
    const dialogRef = this.modalService.openPopup(
      {
        message: resp.message,
        isFooterRequired: true,
        isMultiple: false,
      },
      ModalPopupMessages.Warning,
      MessagePopupComponent,
      popupWidth.deletePopup
    );

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: unknown) => {
        if (result !== true) {
          return;
        }
        const processPayload = this.buildClearancePayload(
          resp.data?.processClearancePayload
        );
        if (!processPayload) {
          return;
        }
        this.isCustomsCityClearanceSubmitting = true;
        this.executeProcessCustomsCityClearance(processPayload);
      });
  }

  private executeProcessCustomsCityClearance(
    payload: CustomsCityProcessClearanceRequest
  ): void {
    this.commonService
      .processCustomsCityClearance(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.isCustomsCityClearanceSubmitting = false;
        })
      )
      .subscribe({
        next: resp => this.handleCustomsCityClearanceResponse(resp),
        error: (error: HttpErrorResponse) =>
          this.handleCustomsCityClearanceHttpError(error),
      });
  }

  private handleCustomsCityClearanceResponse(
    resp: CustomsCityProcessClearanceResponse
  ): void {
    const statusCode = resp?.statusCode;

    if (statusCode === CustomsCityClearanceStatusCodes.AllQueued) {
      this.handleCustomsCityClearanceSuccess(resp);
      return;
    }
    if (statusCode === CustomsCityClearanceStatusCodes.PartialQueued) {
      this.handleCustomsCityClearancePartial(resp);
      return;
    }
    if (statusCode === CustomsCityClearanceStatusCodes.NoneQueued) {
      this.handleCustomsCityClearanceFailure(resp);
      return;
    }

    this.errorHandlerService.handleApiError(resp);
  }

  private handleCustomsCityClearanceSuccess(
    resp: CustomsCityProcessClearanceResponse
  ): void {
    this.ref.close(true);
    this.snakbarService.openCustomisedSnackBar(
      resp.message,
      ModalPopupMessages.success
    );
  }

  private handleCustomsCityClearancePartial(
    resp: CustomsCityProcessClearanceResponse
  ): void {
    if (hasQueuedCustomsCityClearance(resp)) {
      this.ref.close(true);
    }
    this.openCustomsCityClearanceErrorLog(
      buildCustomsCityClearanceErrorLogData(resp),
      ModalPopupMessages.Warning
    );
  }

  private handleCustomsCityClearanceFailure(
    resp: CustomsCityProcessClearanceResponse
  ): void {
    this.openCustomsCityClearanceErrorLog(
      buildCustomsCityClearanceErrorLogData(resp),
      ModalPopupMessages.errorLog
    );
  }

  private handleCustomsCityClearanceHttpError(error: HttpErrorResponse): void {
    const body = parseCustomsCityClearanceResponse(error?.error);

    if (body?.statusCode === CustomsCityClearanceStatusCodes.NoneQueued) {
      this.handleCustomsCityClearanceFailure(body);
      return;
    }
    if (body?.statusCode === CustomsCityClearanceStatusCodes.PartialQueued) {
      this.handleCustomsCityClearancePartial(body);
      return;
    }

    this.errorHandlerService.handleError(error);
  }

  private openCustomsCityClearanceErrorLog(
    errorLogData: Record<string, string[]>,
    title: string
  ): void {
    this.ref.close(false);
    this.modalService.openPopup(
      {
        errorLogData,
        isFooterRequired: false,
        isForErrorLog: true,
        isForWarning: false,
      },
      title,
      MessagePopupComponent,
      popupWidth.searchPopup
    );
  }

  /* Legacy CBP — May 2026: validate + optional sendCbpClearance (Node routes commented).
  private validateShipmentForCBP() { ... }
  */

  /* Legacy CBP partial confirm submit.
  private sendCBPClearance() { ... }
  */

  private publsihConfirmationText() {
    const matchText =
      this.messagePopupData.code?.confirmText.match(/"([^"]+)"/);
    if (matchText && matchText.length > 0) {
      const extractedText = matchText ? matchText[1] : '';
      this.requiredPublishText = `${extractedText}`;
    } else {
      this.requiredPublishText = '';
    }
  }
  // Chips Autocomplete Methods
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add email if valid
    if (value) {
      this.selectedEmails.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();
    this.emailCtrl.setValue(null);
  }

  remove(email: string): void {
    const index = this.selectedEmails.indexOf(email);

    if (index >= 0) {
      this.selectedEmails.splice(index, 1);
      if (email === this.currentUserEmail) {
        this.isCheckboxChecked = false;
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    if (!this.selectedEmails.includes(value)) {
      this.selectedEmails.push(value);
    }
    this.emailInput.nativeElement.value = '';
    this.emailCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    if (!value || typeof value !== 'string') {
      return this.allEmails.filter(e => !this.selectedEmails.includes(e));
    }
    const filterValue = value.toLowerCase().trim();
    if (!filterValue) {
      return this.allEmails.filter(e => !this.selectedEmails.includes(e));
    }
    return this.allEmails.filter(
      email =>
        email &&
        email.toLowerCase().includes(filterValue) &&
        !this.selectedEmails.includes(email)
    );
  }

  private extractEmailsFromArray(data: any[]): string[] {
    return data
      .filter((item: any) => {
        if (typeof item === 'string' && item.trim()) {
          return true;
        }
        if (
          typeof item === 'object' &&
          item !== null &&
          item.name &&
          typeof item.name === 'string' &&
          item.name.trim()
        ) {
          return true;
        }
        return false;
      })
      .map((item: any) => {
        if (typeof item === 'string') {
          return item.trim();
        }
        if (typeof item === 'object' && item.name) {
          return item.name.trim();
        }
        return null;
      })
      .filter((email: any) => email !== null && email !== '');
  }

  private fetchUserEmails(): void {
    this.commonService
      .getMasterLookUp('userEmail')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response?.statusCode === StatusCodes.Success) {
            if (response.data && Array.isArray(response.data)) {
              this.allEmails = this.extractEmailsFromArray(response.data);
            } else if (response.data) {
              const emailArray =
                response.data.emails || response.data.userEmails || [];
              this.allEmails = this.extractEmailsFromArray(emailArray);
            }
            this.emailCtrl.updateValueAndValidity();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
          this.allEmails = [];
        },
      });
  }

  private loadCurrentUserEmailFromStorage(): void {
    this.currentUserEmail = readLoggedInUserEmailFromStorage();
    this.applySelfEmailAfterProfileLoad();
  }

  private applySelfEmailAfterProfileLoad(): void {
    if (
      this.messagePopupData.code?.isForSendInvoiceViaEmail &&
      this.isCheckboxChecked &&
      this.currentUserEmail &&
      !this.selectedEmails.includes(this.currentUserEmail)
    ) {
      this.selectedEmails.push(this.currentUserEmail);
    }
    this.syncManifestSelfEmailIfApplicable();
  }

  private syncManifestSelfEmailIfApplicable(): void {
    if (
      !this.messagePopupData.code?.isForPublishTicketCheckbox ||
      !this.isSendManifestViaEmail ||
      !this.manifestSendToMe
    ) {
      return;
    }
    const email = readLoggedInUserEmailFromStorage();
    if (!email) {
      return;
    }
    this.currentUserEmail = email;
    if (!this.manifestSelectedEmails.includes(email)) {
      this.manifestSelectedEmails = [...this.manifestSelectedEmails, email];
    }
  }

  private removeManifestSelfEmailFromChips(): void {
    const selfEmail = readLoggedInUserEmailFromStorage() || this.currentUserEmail;
    if (!selfEmail) {
      return;
    }
    this.manifestSelectedEmails = this.manifestSelectedEmails.filter(
      e => e !== selfEmail
    );
  }

  private fetchInvoiceFileFormats(): void {
    this.commonService
      .getMasterLookups('invoice_file_format')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (
            response?.statusCode === StatusCodes.Success &&
            response.data
          ) {
            this.invoiceFileFormatOptions = response.data.map((item: any) => ({
              id: item.id,
              name: item.name,
            }));
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
          this.invoiceFileFormatOptions = [];
        },
      });
  }

  private generateEmailSubjectAndBody(): void {
    const selectedInvoices = this.messagePopupData.code?.selectedInvoiceData;
    if (
      !selectedInvoices ||
      !Array.isArray(selectedInvoices) ||
      selectedInvoices.length === 0
    ) {
      return;
    }

    const invoiceNumbers = selectedInvoices
      .map((invoice: any) => invoice.invoiceNumber)
      .filter(Boolean);

    const invoiceNumbersStr = invoiceNumbers.join(', ');
    const firstInvoice = selectedInvoices[0];
    const accountNumber = firstInvoice?.accountNumber || '';
    const accountName = firstInvoice?.accountName || '';

    if (selectedInvoices.length > 1) {
      this.emailSubject = ModalPopupMessages.arMultipleInvoiceEmailSubject(
        `${accountNumber} - ${accountName}`,
        invoiceNumbersStr
      );
      this.emailBody = `Invoice Numbers: ${invoiceNumbersStr}`;
    } else {
      const invoiceDate = firstInvoice?.invoiceDate || '';
      this.emailSubject = ModalPopupMessages.arInvoiceEmailSubject(
        invoiceNumbersStr,
        accountNumber,
        accountName,
        invoiceDate
      );
      this.emailBody = `Invoice Number: ${invoiceNumbersStr}`;
    }
  }

  private fetchAccountDetailsForInvoiceEmail(): void {
    if (!this.messagePopupData.code?.isForSendInvoiceViaEmail) {
      return;
    }

    const accountId = this.getAccountIdForInvoiceEmail();

    if (!accountId) {
      return;
    }

    this.commonService
      .fetchAccountById(accountId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (
            response?.statusCode === StatusCodes.Success &&
            response.data?.account
          ) {
            this.mapAccountDataToForm(response.data.account);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
  }

  private getAccountIdForInvoiceEmail(): number | null {
    if (this.messagePopupData.code?.accountId) {
      return this.messagePopupData.code.accountId;
    }

    const selectedInvoices = this.messagePopupData.code?.selectedInvoiceData;
    if (
      selectedInvoices &&
      Array.isArray(selectedInvoices) &&
      selectedInvoices.length > 0
    ) {
      return selectedInvoices[0]?.accountId || null;
    }

    return null;
  }

  private mapAccountDataToForm(accountData: any): void {
    const invoiceFileFormat =
      accountData?.governmentInformation?.invoiceFileFormat;
    if (invoiceFileFormat) {
      this.selectedFileFormats = Array.isArray(invoiceFileFormat)
        ? invoiceFileFormat
        : [invoiceFileFormat];
    }

    const invoiceEmails = this.extractInvoiceEmails(accountData);

    this.addEmailsToSelectedList(invoiceEmails);
  }

  private extractInvoiceEmails(accountData: any): string[] {
    if (accountData?.extra?.selectEmailsForInvoiceNotification?.length > 0) {
      return accountData.extra.selectEmailsForInvoiceNotification;
    }

    if (
      accountData?.governmentInformation?.selectEmailsForInvoiceNotification
        ?.length > 0
    ) {
      return accountData.governmentInformation
        .selectEmailsForInvoiceNotification;
    }

    return [];
  }

  private addEmailsToSelectedList(emails: any[]): void {
    if (!emails || !Array.isArray(emails) || emails.length === 0) {
      return;
    }

    const newEmails = emails.filter(
      (email: string) => email && !this.selectedEmails.includes(email)
    );

    if (newEmails.length > 0) {
      this.selectedEmails = [...this.selectedEmails, ...newEmails];
    }
  }

  public onSendToMeCheckboxChange(isChecked: boolean): void {
    if (!this.currentUserEmail) {
      return;
    }

    if (isChecked) {
      if (!this.selectedEmails.includes(this.currentUserEmail)) {
        this.selectedEmails.push(this.currentUserEmail);
      }
    } else {
      const index = this.selectedEmails.indexOf(this.currentUserEmail);
      if (index >= 0) {
        this.selectedEmails.splice(index, 1);
      }
    }
  }

  private createForm() {
    const { form, errorMessages } = this.formService.generateForm(
      copyRateScaleInfoFormConfig
    , this.destroyRef);
    this.copyRateScaleForm = form;
    this.errorMessages = errorMessages;
  }

  public fetchFormFieldErrorMessage(controlName: string) {
    return this.formService.getErrorMessage(
      this.copyRateScaleForm,
      this.errorMessages,
      controlName
    );
  }

  public checkFormFieldForError(controlName: string) {
    return this.commonService.checkControlError(
      this.copyRateScaleForm,
      controlName
    );
  }

  public fetchFormFieldWidth(event: MouseEvent, controlName: string) {
    this.commonService.setErrorTooltipData(
      event,
      controlName,
      this.setRateScaleCopyInfoWidth,
      this.setRateScaleCopyInfoTooltipEvent,
      this.setRateScaleCopyInfoErrorTooltip
    );
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      input.value = '';
      return;
    }
    const file = input.files[0];
    this.ref.close({ popupClose: true, file });

    input.value = '';
  }

  private fetchApSftpFiles(): void {
    this.accountsPayableService
      .getAllReadyForReconFileNames()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result: any) => {
          if (result?.statusCode === StatusCodes.Success) {
            this.apSftpFilesTableData = result.data || [];
            this.apSftpFilesTotalCount = this.apSftpFilesTableData.length;
            this.isApSftpFilesDataSearched = true;
          } else {
            this.errorHandlerService.handleApiError(result);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
  }

  public validateSelectedAgentsUniformity(): void {
    const selectedRows = this.selectionService.getAllRows();

    if (!selectedRows || selectedRows.length === 0) {
      this.areSelectedAgentsUniform = true;
      this.selectedAgentData = null;
      return;
    }

    const firstAgentData = selectedRows[0]?.agentData;

    if (!firstAgentData || firstAgentData.trim() === '') {
      this.areSelectedAgentsUniform = false;
      this.selectedAgentData = null;
      return;
    }

    const allSameAgent = selectedRows.every(
      row => row?.agentData && row.agentData.trim() === firstAgentData.trim()
    );

    this.areSelectedAgentsUniform = allSameAgent;
    this.selectedAgentData = allSameAgent ? firstAgentData : null;
  }

  public onApSftpFilesSelectionChange(): void {
    if (this.messagePopupData.code?.isForAPInvoiceFetchFromSFTP) {
      this.validateSelectedAgentsUniformity();
    }
  }

  private handleCreateAPInvoice(): void {
    const selectedRows = this.selectionService.getAllRows();

    if (!selectedRows || selectedRows.length === 0) {
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.pleaseSelectAtLeastOneFile,
        ModalPopupMessages.Warning
      );
      return;
    }

    const fileNames = selectedRows.map(row => row?.fileName).filter(Boolean);

    if (fileNames.length === 0) {
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.invalidFileSelection,
        ModalPopupMessages.error
      );
      return;
    }

    const payload = { fileName: fileNames };

    this.accountsPayableService
      .processVendorRecon(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response?.statusCode === StatusCodes.Success) {
            this.snakbarService.openCustomisedSnackBar(
              ModalPopupMessages.vendorReconProcessedSuccessfully,
              ModalPopupMessages.success
            );

            this.ref.close({ popupClose: true, success: true });

            this.navigateToAPInformation(response.data);
          } else if (response?.statusCode === StatusCodes.SuccessfulRequest) {
            this.snakbarService.openCustomisedSnackBar(
              response.message,
              ModalPopupMessages.error
            );
          } else {
            this.errorHandlerService.handleApiError(response);
          }
        },
      });
  }

  private navigateToAPInformation(data: any): void {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.noAPInvoiceDataReceived,
        ModalPopupMessages.Warning
      );
      return;
    }

    const invoiceIds = Array.isArray(data) ? data : [data];

    if (invoiceIds.length === 0) {
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.noAPInvoiceDataReceived,
        ModalPopupMessages.Warning
      );
      return;
    }

    this.selectionService.clear();
    this.accountsPayableService.setCreatedInvoiceIdsForEdit({
      invoiceIds: invoiceIds,
      currentInvoiceIndex: 0,
      isFromVendorRecon: true,
    });

    this.router.navigate([pageUrl.accountsPayableInformation], {
      queryParams: {
        mode: ActionIcons.view,
        fromVendorRecon: true,
      },
    });
  }
  public checkShipmentStatus() {
    if (this.selectedRowData?.hawbStatus.trim() === HawbStatus.blocked) {
      this.snakbarService.openCustomisedSnackBar(
        validationErrorMessages.scanBagShipmentNotBagged,
        ModalPopupMessages.error
      );
      return;
    }
    this.ref.close({ popupClose: true, data: this.selectedRowData });
  }

  private processConfirmCode(code: any): boolean {
    const handlers = [
      () => this.handleMultiPieceGatewayConfirm(code),
      () => this.handleMultiPieceShortageSubmit(code),
      () => this.handleCommentClose(code),
      () => this.handleApChargesSelection(code),
      () => this.handleAccountNumberValidation(code),
      () => this.handleUserCreate(code),
      () => this.handleBagShipmentTable(code),
      () => this.handleBagScanShipmentTable(code),
      () => this.handleMultipleBagSelection(code),
      () => this.handleFileTypeClose(code),
      () => this.handleCBPClearance(code),
      () => this.handleMiscellaneousOrUFOAccount(code),
      () => this.handleCopyRateScaleAction(code),
      () => this.handleAPInvoiceFetch(code),
      () => this.handleSendInvoiceViaEmailAction(code),
      () => this.handleAssociateUfoShipments(code),
      () => this.handleInvoiceDatePrompt(code),
    ];

    for (const handler of handlers) {
      const result = handler();
      if (result !== null) {
        return result;
      }
    }

    this.ref.close(true);
    return false;
  }

  private handleMultiPieceGatewayConfirm(code: any): boolean | null {
    if (!code?.isForMultiPieceGatewayConfirm) {
      return null;
    }
    if (this.isMultiPieceGatewayConfirmDisabled()) {
      return true;
    }
    this.ref.close({
      popupClose: true,
      multiPieceGatewayConfirm: true,
      physicalPieceCount: Number.parseInt(this.multiPiecePhysicalCountInput, 10),
    });
    return false;
  }

  private handleMultiPieceShortageSubmit(code: any): boolean | null {
    if (!code?.isForMultiPieceShortageGrid) {
      return null;
    }
    const expected = code.physicalPieceCount ?? 0;
    const selectedHawbIds = this.selectionService
      .getAllRows()
      .map((row: any) => row.hawbId)
      .filter((id: any) => id != null && id !== '');
    if (selectedHawbIds.length !== expected) {
      this.multiPieceSelectionMismatchText =
        ModalPopupMessages.multiPieceSelectionMismatch(
          expected,
          selectedHawbIds.length
        );
      return true;
    }
    const comments = this.multiPieceGatewayComments?.trim();
    this.selectionService.clear();
    this.ref.close({
      popupClose: true,
      multiPieceShortageSubmit: true,
      selectedHawbIds,
      comments: comments || undefined,
    });
    return false;
  }

  private handleCommentClose(code: any): boolean | null {
    if (this.shouldCloseWithComment(code)) {
      this.ref.close({ popupClose: true, comments: this.confirmValue });
      return false;
    }
    return null;
  }

  private handleAssociateUfoShipments(code: any): boolean | null {
    if (!code.isForAssociateUfoShipments) {
      return null;
    }
    const rows = this.selectionService.getAllRows();
    const hawbIds = rows
      .map((r: any) => r.hawbId ?? r.id)
      .filter((id: any) => id != null && id !== '')
      .map((id: any) =>
        typeof id === 'string' ? Number.parseInt(id, 10) : Number(id)
      )
      .filter((n: number) => !Number.isNaN(n));

    if (hawbIds.length === 0 || !this.ufoSelectedAccount) {
      return null;
    }

    const accountOpt = this.ufoAccountOptions.find(
      o => o.value === String(this.ufoSelectedAccount)
    );
    const label = accountOpt?.label?.trim() ?? '';
    const dashIdx = label.indexOf('-');
    const accountNumber =
      dashIdx === -1 ? label : label.slice(0, dashIdx).trimEnd();

    const payload = {
      hawbIds,
      accountId: Number(this.ufoSelectedAccount),
      accountNumber,
    };

    this.hawbService
      .updateUFOShipments(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response?.statusCode === StatusCodes.Success) {
            this.selectionService.clear();
            this.ref.close({
              popupClose: true,
              success: true,
              data: response?.data,
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
    return true;
  }

  private handleApChargesSelection(code: any): boolean | null {
    if (code.isForApChargesSelection || code.isForArChargesSelection) {
      const selectedRows = this.selectionService.getAllRows();
      this.ref.close({ popupClose: true, selectedRows });
      this.selectionService.clear();
      return false;
    }
    return null;
  }

  private handleAccountNumberValidation(code: any): boolean | null {
    if (this.shouldValidateAccountNumber(code)) {
      this.validateAccountNumber(this.confirmValue);
      return false;
    }
    return null;
  }

  private handleUserCreate(code: any): boolean | null {
    if (code.isForUserCreate) {
      this.ref.close({
        email: this.confirmValue,
        popupClose: true,
        clickedIcon: true,
      });
      return false;
    }
    return null;
  }

  private handleBagShipmentTable(code: any): boolean | null {
    if (code.renderBagShipmentTable) {
      if (
        this.selectedRowData &&
        !this.selectedRowData.isRoutingConfigured
      ) {
        this.snakbarService.openCustomisedSnackBar(
          ModalPopupMessages.routingRequiredForBagging,
          ModalPopupMessages.error
        );
        return true;
      }
      this.ref.close({ popupClose: true, data: this.selectedRowData });
      return false;
    }
    return null;
  }

  private handleBagScanShipmentTable(code: any): boolean | null {
    if (code.renderBagScanShipmentTable) {
      this.checkShipmentStatus();
      return false;
    }
    return null;
  }

  private handleMultipleBagSelection(code: any): boolean | null {
    if (code.isForMultipleBagSelection) {
      this.ref.close({ popupClose: true, selectedBag: this.selectedRowData });
      return false;
    }
    return null;
  }

  private handleFileTypeClose(code: any): boolean | null {
    if (this.shouldCloseWithFileType(code)) {
      return this.handleCloseWithFileType();
    }
    return null;
  }

  private handleCBPClearance(code: any): boolean | null {
    if (code.isSendCBPClearance) {
      this.submitCustomsCityClearance();
      return false;
    }
    return null;
  }

  private handleMiscellaneousOrUFOAccount(code: any): boolean | null {
    if (code.hasMiscellaneousAccount || code.hasUFOAccount) {
      this.ref.close({ popupClose: true });
      return false;
    }
    return null;
  }

  private handleCopyRateScaleAction(code: any): boolean | null {
    if (code.forCopyRateScale) {
      this.handleCopyRateScale();
      return false;
    }
    return null;
  }

  private handleAPInvoiceFetch(code: any): boolean | null {
    if (code.isForAPInvoiceFetchFromSFTP) {
      this.handleCreateAPInvoice();
      return false;
    }
    return null;
  }

  private handleSendInvoiceViaEmailAction(code: any): boolean | null {
    if (code.isForSendInvoiceViaEmail) {
      this.handleSendInvoiceViaEmail();
      return false;
    }
    if (code.isForPublishTicketCheckbox) {
      const result: any = {
        popupClose: true,
        checkboxValue: this.isCheckboxChecked,
      };
      if (this.isSendManifestViaEmail) {
        result.manifestEmailPayload = this.getManifestEmailPayload();
      }
      this.ref.close(result);
      return false;
    }
    return null;
  }

  private handleCloseWithFileType(): boolean {
    if (
      this.rangeOptions &&
      this.rangeOptions.length > 0 &&
      this.selectedRanges.size === 0
    ) {
      this.snakbarService.openCustomisedSnackBar(
        validationErrorMessages.warningMsgForNumberRange,
        ModalPopupMessages.error
      );
      return true;
    }

    const selectedRangeIndices = Array.from(this.selectedRanges);
    this.ref.close({
      popupClose: true,
      fileType: this.fileType,
      selectedRanges: selectedRangeIndices,
    });
    return false;
  }

  private handleSendInvoiceViaEmail(): void {
    const selectedInvoices = this.messagePopupData.code?.selectedInvoiceData;

    if (
      !selectedInvoices ||
      !Array.isArray(selectedInvoices) ||
      selectedInvoices.length === 0
    ) {
      return;
    }

    const arInvoiceIds = selectedInvoices
      .map((invoice: any) => invoice.arInvoiceId || invoice.id)
      .filter(Boolean);

    const formatNames = this.selectedFileFormats
      .map((formatId: number) => {
        const format = this.invoiceFileFormatOptions.find(
          f => f.id === formatId
        );
        return format?.name?.toLowerCase() || '';
      })
      .filter(Boolean);

    const payload = {
      arInvoiceId: arInvoiceIds,
      emailIds: this.selectedEmails,
      format: formatNames,
      subject: this.emailSubject,
      body: this.emailBody,
      publishBatchId: this.messagePopupData.code?.publishBatchId ?? null,
    };

    this.commonService
      .sendARInvoiceViaEmail(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response?.statusCode === StatusCodes.Success) {
            const invoiceCount = arInvoiceIds.length;
            const isPublishFlow = this.messagePopupData.code?.isPublishFlow;
            let successMessage: string;
            if (isPublishFlow) {
              successMessage = ModalPopupMessages.arInvoicePublishedSuccess(invoiceCount);
            } else if (invoiceCount === 1) {
              successMessage = ModalPopupMessages.arInvoicePublishedToCustomer;
            } else {
              successMessage = ModalPopupMessages.emailSentSuccessfully(invoiceCount);
            }
            this.snakbarService.openCustomisedSnackBar(
              successMessage,
              ModalPopupMessages.success
            );
            this.ref.close({ popupClose: true, success: true });
          } else {
            this.errorHandlerService.handleApiError(response);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
  }

  public validateARShipmentSelection(): void {
    const selectedRows = this.selectionService.getAllRows();

    if (!selectedRows || selectedRows.length === 0) {
      this.hasNotAutoRatedSelection = false;
      return;
    }

    this.hasNotAutoRatedSelection = selectedRows.some((row: any) => {
      return row?.isAutoRated === false;
    });
  }

  public onArChargesSelectionChange(): void {
    if (this.messagePopupData.code?.isForArChargesSelection) {
      this.validateARShipmentSelection();
    }
  }

  public onSendManifestViaEmailToggle(checked: boolean): void {
    this.isSendManifestViaEmail = checked;
    if (checked) {
      this.syncManifestSelfEmailIfApplicable();
    } else {
      this.resetManifestEmailFields();
    }
  }

  public onManifestSendToMeCheckboxChange(event: MatCheckboxChange): void {
    if (event.checked) {
      this.manifestEmailError = '';
      this.syncManifestSelfEmailIfApplicable();
      return;
    }
    this.removeManifestSelfEmailFromChips();
  }

  public addManifestEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (!value) {
      event.chipInput!.clear();
      this.manifestEmailCtrl.setValue(null);
      return;
    }
    if (!ValidatorPattern.emailUserValidator.test(value)) {
      this.manifestEmailError = ModalPopupMessages.invalidEmailAddress;
      return;
    }
    this.manifestEmailError = '';
    if (!this.manifestSelectedEmails.includes(value)) {
      this.manifestSelectedEmails.push(value);
    }
    event.chipInput!.clear();
    this.manifestEmailCtrl.setValue(null);
  }

  public removeManifestEmail(email: string): void {
    const index = this.manifestSelectedEmails.indexOf(email);
    if (index >= 0) {
      this.manifestSelectedEmails.splice(index, 1);
      const selfEmail = readLoggedInUserEmailFromStorage() || this.currentUserEmail;
      if (selfEmail && email === selfEmail) {
        this.manifestSendToMe = false;
      }
    }
  }

  public onManifestEmailBlur(): void {
    const value = (this.manifestEmailCtrl.value || '').trim();
    if (!value) {
      this.manifestEmailError = '';
      return;
    }
    if (ValidatorPattern.emailUserValidator.test(value)) {
      this.manifestEmailError = '';
    } else {
      this.manifestEmailError = ModalPopupMessages.invalidEmailAddress;
    }
  }

  private fetchManifestPublishFormats(agentId: number): void {
    this.manifestService
      .getManifestPublishFormats(agentId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode === StatusCodes.Success && Array.isArray(res?.data)) {
            this.manifestFormatOptions = res.data.map((x: any) => ({
              id: x.id ?? x.stationFormatId,
              stationFormatId: x.stationFormatId ?? x.id,
              formatCode: x.formatCode,
              formatDescription: x.formatDescription,
              outputFileExtension: x.outputFileExtension,
              name: x.name ?? x.formatName ?? x.formatCode ?? String(x.id ?? ''),
            }));
          }
        },
        error: (err: HttpErrorResponse) => {
          this.errorHandlerService.handleError(err);
        },
      });
  }

  public onManifestFormatChange(): void {
    this.selectedManifestFileFormat = null;
    this.manifestFileFormatOptions = [];
    const selected = this.selectedManifestFormat;
    if (!selected) {
      return;
    }
    const ext = (selected.outputFileExtension ?? '').toString().trim();
    if (ext) {
      const idKey = ext.toLowerCase();
      this.manifestFileFormatOptions = [{ id: idKey, name: idKey }];
      this.selectedManifestFileFormat = idKey;
    }
  }

  public onManifestAttachmentSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const remaining = this.maxManifestAttachments - this.manifestAttachmentList.length;
    if (remaining <= 0) {
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.maxAttachmentsReached,
        ModalPopupMessages.Warning
      );
      input.value = '';
      return;
    }
    const files = Array.from(input.files).slice(0, remaining);
    input.value = '';
    this.uploadManifestAttachments(files);
  }

  private uploadManifestAttachments(files: File[]): void {
    if (files.length === 0) return;
    const file = files[0];
    const rest = files.slice(1);
    this.isManifestAttachmentUploading = true;
    this.commonService
      .attachmentSignedUrl({ fileName: file.name })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode === StatusCodes.Success && res?.data) {
            const signedData = res.data;
            this.commonService
              .attachmentStoredSignedUrl(signedData, file)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe({
                next: (uploadRes: any) => {
                  this.manifestAttachmentList = [
                    ...this.manifestAttachmentList,
                    { displayName: file.name, storedFileName: signedData.fileName },
                  ];
                  this.isManifestAttachmentUploading = false;
                  if (rest.length > 0) {
                    this.uploadManifestAttachments(rest);
                  }
                },
                error: (err: HttpErrorResponse) => {
                  this.errorHandlerService.handleError(err);
                  this.isManifestAttachmentUploading = false;
                },
              });
          } else {
            this.errorHandlerService.handleApiError(res);
            this.isManifestAttachmentUploading = false;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.errorHandlerService.handleError(err);
          this.isManifestAttachmentUploading = false;
        },
      });
  }

  public triggerManifestAttachmentInput(event: Event): void {
    event.preventDefault();
    (this.manifestAttachmentInput as any)?.nativeElement?.click();
  }

  public removeManifestAttachment(index: number): void {
    this.manifestAttachmentList = this.manifestAttachmentList.filter(
      (_, i) => i !== index
    );
  }

  public onManifestAttachmentNavigate(event: any): void {
    if (event?.action === 'deleteAttachment' && event?.row) {
      const idx = this.manifestAttachmentList.indexOf(event.row);
      if (idx !== -1) this.removeManifestAttachment(idx);
    }
  }
  public viewManifestAttachment(item: { displayName: string; storedFileName: string }): void {
    return;
  }

  public getManifestEmailDisplayError(): string {
    if (this.manifestEmailError) return this.manifestEmailError;
    if (!this.manifestSendToMe && this.manifestSelectedEmails.length === 0) {
      return ModalPopupMessages.manifestEmailRequired;
    }
    return '';
  }

  public isManifestPublishDisabled(): boolean {
    if (!this.isSendManifestViaEmail) return false;
    if (!this.manifestEmailSubject?.trim()) return true;
    if (!this.selectedManifestFormat) return true;
    if (!this.manifestSendToMe && this.manifestSelectedEmails.length === 0) return true;
    if (!this.selectedManifestFileFormat) return true;
    return false;
  }

  public getManifestEmailPayload(): any {
    const selfEmail =
      this.manifestSendToMe
        ? readLoggedInUserEmailFromStorage() || this.currentUserEmail
        : '';
    const extraOnly = selfEmail
      ? this.manifestSelectedEmails.filter(e => e !== selfEmail)
      : this.manifestSelectedEmails;
    const additionalEmails = extraOnly.length ? extraOnly.join(',') : '';
    const stationFormatId = this.selectedManifestFormat?.id ?? this.selectedManifestFormat?.stationFormatId ?? null;
    const fileFormat = this.selectedManifestFileFormat
      ? String(this.selectedManifestFileFormat).toLowerCase()
      : null;
    return {
      isSendEmail: true,
      sendToMe: this.manifestSendToMe,
      additionalEmails,
      stationFormatId,
      fileFormat,
      emailSubject: this.manifestEmailSubject,
      attachmentFileNames: this.manifestAttachmentList.map(a => a.storedFileName),
    };
  }

  private resetManifestEmailFields(): void {
    this.manifestSendToMe = true;
    this.manifestSelectedEmails = [];
    this.manifestEmailCtrl.setValue(null);
    this.manifestEmailError = '';
    this.selectedManifestFormat = null;
    this.selectedManifestFileFormat = null;
    this.manifestFileFormatOptions = [];
    this.manifestEmailSubject = '';
    this.manifestAttachmentList = [];
  }

  private setupUfoAccountAutocomplete(): void {
    this.filteredUfoAccountOptions = this.ufoAccountCtrl.valueChanges.pipe(
      startWith(''),
      map((val: string | null) => {
        const filterValue =
          typeof val === 'string'
            ? val.toLowerCase().replaceAll(/[\s-]/g, '')
            : '';
        if (!filterValue) {
          return this.ufoAccountOptions;
        }
        return this.ufoAccountOptions.filter(option =>
          option.label.replaceAll(/[\s-]/g, '').toLowerCase().includes(filterValue)
        );
      }),
      tap((filtered: { value: string; label: string }[]) => {
        const val = this.ufoAccountCtrl.value;
        if (
          filtered?.length === 1 &&
          typeof val === 'string' &&
          val.trim() &&
          this.ufoSelectedAccount !== filtered[0].value
        ) {
          setTimeout(() => this.onUfoAccountSelected(filtered[0]), 0);
        }
      }),
      takeUntilDestroyed(this.destroyRef)
    );
  }

  public onUfoAccountSelected(account: { value: string; label: string }): void {
    this.ufoSelectedAccount = account.value;
    this.ufoAccountCtrl.setValue(account.label);
    this.cdRef.detectChanges();
  }

  public onUfoAccountInputBlur(): void {
    const currentValue = this.ufoAccountCtrl.value?.trim() || '';
    if (!currentValue) {
      this.ufoSelectedAccount = null;
      this.cdRef.detectChanges();
      return;
    }
    const normalizedInput = currentValue.replaceAll(/[\s-]/g, '').toLowerCase();
    const hasMatch = this.ufoAccountOptions.some(
      opt =>
        opt.label.replaceAll(/[\s-]/g, '').toLowerCase() === normalizedInput ||
        opt.label.toLowerCase() === currentValue.toLowerCase()
    );
    if (!hasMatch) {
      this.ufoSelectedAccount = null;
    }
    this.cdRef.detectChanges();
  }

  private hasUfoAccountForProceed(): boolean {
    if (this.ufoSelectedAccount) {
      return true;
    }
    const v = this.ufoAccountCtrl?.value;
    return typeof v === 'string' && v.trim().length > 0;
  }

  private normalizeUfoShipmentRow(row: any): any {
    const id = row.hawbId;
    return { ...row, id };
  }

  private fetchAccountDetails(): void {
    this.hawbService
      .checkAccountDetails()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: any) => {
          if (data?.code === StatusCodes.Success && data?.data?.length) {
            this.ufoAccountOptions = data.data
              .filter(
                (account: any) =>
                  (account.isufoaccount) === false
              )
              .map((account: any) => ({
                value: String(account.id),
                label: `${account.number} - ${account.name}`,
              }));
            this.setupUfoAccountAutocomplete();
          } else if (data?.code === StatusCodes.SuccessfulRequest) {
            this.ufoAccountOptions = [];
            this.setupUfoAccountAutocomplete();
          } else if (data?.code && data?.code !== StatusCodes.Success) {
            this.errorHandlerService.handleApiError(data);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
  }

  private fetchUFOShipments(): void {
    const payload = {
      paging: { ...this.ufoShipmentsSearchPayload.paging },
    };
    this.hawbService
      .getUFOShipments(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result: any) => {
          if (result?.statusCode === StatusCodes.Success) {
            const rows = result?.data?.ufoShipments || [];
            this.ufoShipmentsRawData = rows.map((row: any) =>
              this.normalizeUfoShipmentRow(row)
            );
            this.ufoShipmentsTotalCount =
              result?.data?.totalCount ?? this.ufoShipmentsRawData.length;
            this.applyUfoFiltersToTableData();
            this.isUfoShipmentsDataSearched = true;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.errorHandlerService.handleError(error);
        },
      });
  }

  private filterUfoShipmentsLocally(rows: any[]): any[] {
    if (!rows?.length) {
      return [];
    }
    const shipperQuery = this.ufoFilterShipperConsignee?.trim().toLowerCase() ?? '';
    const hasShipper = shipperQuery.length > 0;
    const hasStart = !!this.ufoFilterStartDate;
    const hasEnd = !!this.ufoFilterEndDate;

    return rows.filter(row => {
      if (hasShipper) {
        const name = String(row?.shipperConsigneeName ?? '').toLowerCase();
        if (!name.includes(shipperQuery)) {
          return false;
        }
      }
      if (hasStart || hasEnd) {
        if (!this.ufoShipmentRowMatchesDateRange(row)) {
          return false;
        }
      }
      return true;
    });
  }

  private ufoShipmentRowMatchesDateRange(row: any): boolean {
    const rowDate = this.parseUfoShipmentCreatedDate(row?.shipmentCreatedDateAndTime);
    if (!rowDate) {
      return false;
    }
    const rowDay = new Date(
      rowDate.getFullYear(),
      rowDate.getMonth(),
      rowDate.getDate()
    ).getTime();
    if (this.ufoFilterStartDate) {
      const s = new Date(this.ufoFilterStartDate);
      const startDay = new Date(s.getFullYear(), s.getMonth(), s.getDate()).getTime();
      if (rowDay < startDay) {
        return false;
      }
    }
    if (this.ufoFilterEndDate) {
      const e = new Date(this.ufoFilterEndDate);
      const endDay = new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      if (rowDay > endDay) {
        return false;
      }
    }
    return true;
  }

  private parseUfoShipmentCreatedDate(value: unknown): Date | null {
    if (value == null || value === '') {
      return null;
    }
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }
    if (typeof value === 'string' || typeof value === 'number') {
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    return null;
  }
}
